import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { SearchResultsPanelComponent } from 'components/accordion/search-widget/search-results-panel/search-results-panel.component';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild()
  ],
  declarations: [
    SearchResultsPanelComponent
  ],
  exports: [
    SearchResultsPanelComponent
  ]
})
export class SearchResultsPanelModule {}
